import { configureStore } from '@reduxjs/toolkit';
import filtersReducer  from '../reducers/Beacon4BlendedFiltersReducer';
import kpiDataReducer  from '../reducers/Beacon4BlendedKpiDataReducer';

export const store = configureStore({
  reducer: {
    filters: filtersReducer,
    kpiData: kpiDataReducer,
  },
});
